import React from 'react'
import { useState } from 'react'
import './login1.css'
import Spinner from '../content/Spinner';
//import Home from './Home';


const Login = (props) => {

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errormsg, setErrormsg] = useState(false);
  const [spinner, setSpinner] = useState(false);

  const handleSubmit = async e => {
    
    e.preventDefault();
    setSpinner(true)
    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        "email_id": username,
        "password": password
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "manual"
      };

      await fetch(process.env.REACT_APP_BASE_URL+"/api/support/login", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.success === 1) {
            // setUser(result.token)
            localStorage.setItem('loginToken', result.token);
            props.updateIsLoggedIn(true)
            setSpinner(false)
          } else {
            setErrormsg(true)
            
            
          }
          setSpinner(false) 
        });

    }
    catch (error) {
      console.log(error);
    }

  }

  return (
      <div className="login-page">
        {spinner && <Spinner />}
        <div className="form">
          <form className="login-form" onSubmit={handleSubmit}>
            <input type="text" placeholder="username" value={username} onChange={({ target }) => {setUsername(target.value)}} />
            <input type="password" placeholder="password" value={password} onChange={({ target }) => setPassword(target.value)} />
            <button type='submit'>login</button>
            {errormsg ? <p className="message">Invalid Username Or Passwrod</p> : ""}
          </form>
        </div>
      </div>
  );
}

export default Login




